module.exports = __webpack_public_path__ + "img/合并3.5627b33b.svg";